module.exports = __webpack_public_path__ + "assets/images/ChageOrder.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/ChageOrder.png
// module id = 1350
// module chunks = 1